module.exports = {"513223100":"凤仪镇","513223101":"南新镇","513223102":"叠溪镇","513223105":"富顺镇","513223107":"土门镇","513223109":"洼底镇","513223110":"沙坝镇","513223111":"渭门镇","513223112":"黑虎镇","513223113":"沟口镇","513223114":"赤不苏镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513223.json
// module id = 2532
// module chunks = 0